exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".SMS-header[data-v-db3f3aa8]{display:flex;align-items:center;justify-content:space-between;height:36px;background-color:#eee;font-size:16px;padding:0 30px;margin:20px 0}.SMS-main[data-v-db3f3aa8]{padding:0 30px}.form-sub[data-v-db3f3aa8]{text-align:right;margin-bottom:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-db3f3aa8&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/SMSManage/index.vue
// module id = 634
// module chunks = 0